import { Box, Stack, Typography } from "@mui/material"
import HorizontalScrollBar from './HorizontalScrollbar.js'
import Loader from './Loader'

const SimilarExercises = ({ targetMuscleExercises, equipmentExercises }) => {
  return (
    <Box sx={{ mt: { lg: '50px', xs: '0' }}}>

{/* Same muscle group */}
      <Typography variant="h3" mb="20px" padding="30px 0" mt= "-30px" sx={{ ml: '70px' }}
                  fontSize={{ xs: '2rem', sm: '2.5rem', md:'3rem', lg: '3.5rem',}}
      >
        Exercises that target the same muscle group:
      </Typography>

      <Stack direction="row" sx={{ p: '2', position: 'relative'}}>
        {targetMuscleExercises.length ?<HorizontalScrollBar  data={targetMuscleExercises} />
        : <Loader />}
      </Stack>

{/* Same equipment */}
      <Typography variant="h3" mb="20px" padding="30px 0" mt= "50px" sx={{ ml: '70px' }}
                  fontSize={{ xs: '2rem', sm: '2.5rem', md:'3rem', lg: '3.5rem',}}
      >
        Exercises that target the same equipment:
      </Typography>

      <Stack direction="row" sx={{ p: '2', position: 'relative'}}>
        {equipmentExercises.length ?<HorizontalScrollBar  data={equipmentExercises} />
        : <Loader />}
      </Stack>
    </Box>
  )
}
export default SimilarExercises